// DEPRECATED
export const getData = (url, setInteractions, setLoading) => {
  fetch(url, { credentials: 'include' })
    .then(data => data.json())
    .then(data => {
      setInteractions(data.interactions);
      setLoading(false);
    });
};
